// extracted by mini-css-extract-plugin
export default {"empty":"Chart_empty__sHH8n"};